module.exports = __webpack_public_path__ + "img/picture_product1.ac7e6e79.png";